import { useMemo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { RadioButton } from 'src/modules/common/components/Radio/RadioButton';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { ComboVariantEnum } from 'src/modules/common/ComboVariantEnum.ts';
import clsx from 'clsx';

export type DeliveryTypeProps = {
    variant: ComboVariantEnum;
    mounted: boolean;
    onChange: (selected: boolean) => void;
    isMobile?: boolean;
}

export const DeliveryType = ({ variant, mounted, onChange, isMobile }: DeliveryTypeProps) => {
    const message = useMemo(() => {
        switch (variant) {
            case ComboVariantEnum.Both:
                return (
                    <I18n messageId={MESSAGES.mountedOrUnmounted}/>
                );
            case ComboVariantEnum.Mounted:
                return (
                    <I18n messageId={MESSAGES.deliveredMnt}/>
                );
            case ComboVariantEnum.Unmounted:
                return (
                    <I18n messageId={MESSAGES.deliveredUnmnt}/>
                );
            default:
                return '';
        }
    }, [variant]);

    return (
        <div className={clsx({
            'vss-delivery-type': true,
            'vss-delivery-type--mobile': isMobile,
        })}
        >
            <p className="vss-delivery-type__description">
                {message}
            </p>

            {variant === ComboVariantEnum.Both && (
                <div className="vss-delivery-type__actions">
                    <RadioButton
                        id="d_yes"
                        name="var"
                        value={ComboVariantEnum.Mounted}
                        onChange={() => onChange(true)}
                        checked={mounted}
                    >
                        <I18n messageId={MESSAGES.yes}/>
                    </RadioButton>

                    <RadioButton
                        checked={!mounted}
                        id="d_no"
                        name="var"
                        value={ComboVariantEnum.Unmounted}
                        onChange={() => onChange(false)}
                    >
                        <I18n messageId={MESSAGES.no}/>
                    </RadioButton>
                </div>
            )}
        </div>
    );
};
